import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useNewsList() {
    // Use toast
    const toast = useToast();

    const refNewsListTable = ref(null);

    // Table Handlers
    // Alineación estándar de las tablas del panel (mismo patrón que revisiones-admin):
    // `...styleTable` centra cabecera y contenido; `thClass: styleTable.thClass`
    // centra solo la cabecera y deja el contenido a la izquierda.
    const styleTable = {
        thClass: 'text-center',
        tdClass: 'text-center'
    };

    let tableColumns = [
        { key: 'display_order', sortable: true, label: 'Orden', ...styleTable },
        { key: 'title', sortable: true, label: 'Noticia', thClass: styleTable.thClass },
        { key: 'source', sortable: true, label: 'Medio', thClass: styleTable.thClass },
        { key: 'active', sortable: true, label: 'Estado', ...styleTable },
        { key: 'actions', sortable: false, label: 'Opciones', ...styleTable }
    ];

    const perPage = ref(10);
    const totalNews = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('');
    const isSortDirDesc = ref(false);

    const dataMeta = computed(() => {
        const localItemsCount = refNewsListTable.value ? refNewsListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalNews.value,
        }
    });

    const refetchData = () => {
        refNewsListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        refetchData();
    });

    const fetchNewsList = (ctx, callback) => {
        store
            .dispatch('app-news/fetchNewsList', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value
            })
            .then(response => {
                const { news, total } = response.data;
                callback(news);
                totalNews.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista de noticias',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            })
    };

    return {
        fetchNewsList,
        tableColumns,
        perPage,
        currentPage,
        totalNews,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refNewsListTable,

        refetchData
    }
}
